/**
 * 公用的国际化文件：<英文>
 *
 * 在html属性中的使用示例：（注意属性名字前要有冒号）
 * <el-tooltip :content="$t('c.notice')" placement="bottom">
 * 在html模版中的使用示例：
 * <span>{{ $t('c.welcome') }}</span>
 * 在js代码中的使用示例：
 * window.document.title = this.$t('c.projectTitle')
 * 支持动态属性示例：
 * {{ $t(`c.${scope.row.operationStatus}`) }}
 *
 * 注意1:
 *    公用的国际化标识是以'c.'开头,
 *    业务应用的国际化默认是以'm.'开头, 可以自行调整
 *    但是不可以使用c(公用的)和el(ElementUI的), 避免冲突
 * 注意2:
 *    属性名称使用首字母小写的驼峰格式命名, 或下划线分隔单词
 *    必须使用英文，禁止使用拼音及拼音简写
 *    尽量做到望文知义，可以长一些，再长一些，保证代码可阅读性
 *    正确：projectTitle, studentName, min_waiting_time
 *    正确：loginPasswordVerifyFailedAutoUnlockPeriod,即：登录密码验证失败自动解锁时长
 *    正确：login_collision_attack_failed_count,即：登录碰撞攻击失败次数
 *    错误：name(这是什么阿猫阿狗), shijian(拼音时间或是事件或是??), pyjx(我猜是拼音简写, 错! 正确答案, 嗯...让我想想)
 * @author luwei
 * @version 1.0.0, 2019-03-16
 */
export const c = {
  login: 'Login',
  rememberMe: 'Remember Me',
  welcome: 'Welcome',
  fullScreen: 'Full Screen',
  exitFullScreen: 'Exit Full Screen',
  message: 'Message',
  popIndentMenuBar: 'Expand/Collapse Menu Tree',
  exit: 'Exit',
  Logout: 'Log Out',
  changePassword: 'Change Password',
  profile: 'Profile',
  chinese: 'Chinese',
  english: 'English',
  enterUsername: 'Please enter username',
  enterPassword: 'Please enter password',
  enterIdentifyCode: 'Please enter verification code',
  enterCorrectIdentifyCode: 'Please enter correct verification code',
  fuzzySearch: 'Fuzzy Search',
  more: 'More',
  success: 'Success',
  failure: 'Failure',
  result: 'Result',
  tips: 'Tips',
  list: 'List',
  related: 'Related',
  operationSuccess: 'Operation Successful',
  search: {
    placeholder: 'Fuzzy Search',
    "enterSearch": "Enter search",
    "existing": "Existing",
    "parallelQueryConditions": "Parallel query conditions",
    "multipleParallelQuery": "Multiple parallel query",
    "advanced": "Advanced",
    "startDate": "Start date",
    "endDate": "End date",
    "to": "To"
  },
  table: {
    operation: 'Operation',
    new: 'New',
    view: 'View',
    edit: 'Edit',
    delete: 'Delete',
    deleteRelation: 'Delete Relation',
    add: 'Add',
    deleteRowConfirm: 'Confirm to disable this record?',
    forbid: 'Confirm to disable this user?',
    enable: 'Confirm to enable this user?',
    deleteRelationRowConfirm: 'Confirm to delete this relation?',
    deleteBatchConfirm1: 'Confirm to delete selected ',
    deleteBatchConfirm2: ' records?',
    deleteBatchRelationConfirm2: ' relations?',
    pleaseSelectForDelete: 'Please select records to delete',
    pleaseSelectForEdit: 'Please select records to edit in batches',
    pleaseSelectForAdd: 'Please select relations to add',
    tip: {
      add: 'Add Relation',
      createNewRecord: 'Create New Record',
      deleteBatchRecord: 'Batch Delete Selected Records',
      deleteBatchRelation: 'Batch Delete Selected Relations',
      editBatchRecord: 'Batch Edit Selected Records',
      searchFields: 'Search Fields: '
    }
  },
  dialog: {
    save: 'Save',
    submit: 'Submit',
    close: 'Close',
    publish: 'Publish',
    next: 'Next',
    back: 'Back',
    saveAndNext: 'Save and Next',
    saveSuccess: 'Save Successful'
  },
  form: {
    formMissInfo: 'Please complete the missing information!',
    the: 'The',
    alreadyExists: ' already exists!',
    pleaseSelect: 'Please select',
    pleaseInput: 'Please input',
    maximumLength: 'Maximum Length',
    rule: {
      pleaseMail: 'Please enter a valid email address',
      pleaseMobile: 'Please enter a valid mobile number',
      pleaseidNumber: 'Please enter a valid ID number',
      pleaseNumber: 'Please enter a number'
    }
  },
  audit: {
    mySecurityAudit: 'My Security Audit',
    myAuditLog: 'My Audit Log',
    operateTime: 'Operation Time',
    ipAddr: 'IP Address',
    operation: 'Operation',
    operator: 'Operator',
    clientType: 'Client Type',
    operateType: 'Operation Type'
  },
  friendshipLinks: {
    friendshipLinks: 'Friendship Links',
    companyProfile: 'Company Profile',
    companyNews: 'Company News',
    joinUs: 'Join Us',
    contactUs: 'Contact Us'
  },
  hostUnit: {
    name: 'Beijing Nuojun An Information Technology Co., Ltd.',
    officeAddressa: 'Room 301, Zhongjia Building, No. 168, Dazhong Temple East Road, Haidian District, Beijing',
    icpNumber: 'Beijing ICP备案10019042号-1',
    hostUnit: 'Host Unit',
    officeAddress: 'Office Address'
  },
  contactInformation: {
    nationalConsultationPhone: 'National Consultation Phone',
    nuoJunAnForeignAffairsApp: 'NuoJunAn Foreign Affairs APP',
    nuoJunAnForeignAffairsMiniProgram: 'NuoJunAn Foreign Affairs Mini Program'
  },
  notice: {
    notice: 'Notice',
    originator: 'Originator',
    title: 'Title',
    message: 'Message',
    receivers: 'Receivers',
    effectiveDate: 'Effective Date',
    startDate: 'Start Date',
    endDate: 'End Date',
    confirmReceived: 'Confirmed Users',
    extra: 'Extra Info',
    status: 'Status',
    normal: 'Normal',
    overdue: 'Overdue',
    read: 'Read',
    unread: 'Unread'
  },
  SEC_LOGIN: 'User Login',
  SEC_LOGOUT: 'User Logout',
  SEC_MODIFY_PASSWORD: 'Password Change',
  SYS_REQUEST: 'HTTP Request',
  BIZ_OPERATION: 'Business Operation',
  BIZ_TIMER_TASK: 'Scheduled Business Task'
}